import { useCallback, useEffect, useRef } from 'react';

export function useLatestRequestGuard() {
  const sequenceRef = useRef(0);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      sequenceRef.current += 1;
    };
  }, []);

  return useCallback(() => {
    const sequence = sequenceRef.current + 1;
    sequenceRef.current = sequence;
    return () => mountedRef.current && sequenceRef.current === sequence;
  }, []);
}
